var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUpdate = function SvgUpdate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0319 0.7435V3.37478H4.62256C2.49814 3.37478 0.776367 5.14234 0.776367 7.32325C0.776367 7.98647 0.950648 8.60033 1.2331 9.14942L2.81966 7.98956C2.74754 7.77979 2.69946 7.56078 2.69946 7.32634C2.69946 6.23434 3.56185 5.3521 4.62256 5.3521H11.0319V7.98339L16.1611 4.69197V4.03492L11.0319 0.7435ZM14.1178 7.97722C14.19 8.18698 14.238 8.40599 14.238 8.64044C14.238 9.73243 13.3786 10.6147 12.3149 10.6147H5.90562V7.98339L0.776367 11.2748V11.9319L5.90562 15.2233V12.592H12.3149C14.4394 12.592 16.1611 10.8244 16.1611 8.64352C16.1611 7.9803 15.9868 7.36644 15.7044 6.81735L14.1178 7.97722Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpdate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/update.573d89d9.svg";
export { ForwardRef as ReactComponent };